import dayjs from 'dayjs';
// relativeTime plugin is registered globally via dayjsSetup.js.

/**
 * Returns a { relative, absolute } pair for a date-ish input.
 * - relative: "2 hours ago", "in 5 minutes", "just now"
 * - absolute: "2026-04-23 19:04"
 * Use `relative` as the visible label; `absolute` as the tooltip.
 */
export function relativeTime(dateish) {
  if (!dateish) return { relative: '—', absolute: '' };
  const d = dayjs(dateish);
  if (!d.isValid()) return { relative: '—', absolute: '' };
  return {
    relative: d.fromNow(),
    absolute: d.format('YYYY-MM-DD HH:mm')
  };
}

/**
 * Variant used when we want the short form without "ago"/"in" prefix,
 * for dense table cells. E.g. "2h" instead of "2 hours ago".
 */
export function shortRelative(dateish) {
  if (!dateish) return '—';
  const d = dayjs(dateish);
  if (!d.isValid()) return '—';
  return d.fromNow(true); // 'in X' / 'X ago' both collapse to 'X'
}
